import { useSearchParams } from "react-router-dom";
import { Container, DialogContent } from "@mui/material";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { BREAKPOINT, WIDTH } from "../../../constants/breakpoints.js";

//import general components
import BaseDialog from "../../common/base-dialog/base-dialog.jsx";
import DetailsHeader from "../../common/details-header/details-header.jsx";

//import view components
import SearchFormContent from "./search-form-content.jsx";

function HotelSearchForm({ setRequestFlag, openSearchForm, setUid }) {
    //general variables
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const hotelInformation = JSON.parse(sessionStorage.getItem("hotelInformation"));
    const { isHotelInternational } = JSON.parse(sessionStorage.getItem("generalInformation"));

    //handle close modal for the close button of the modal
    const handleClose = () => {
        if (isItinerary || searchParams.get("action") === "edit") {
            searchParams.delete("action");
            setSearchParams(searchParams);
        }
    };

    return (
        <>
            {WIDTH > BREAKPOINT ? (
                <>
                    {openSearchForm ? (
                        <Container maxWidth="xl">
                            <SearchFormContent
                                openSearchForm={openSearchForm}
                                setRequestFlag={setRequestFlag}
                                setUid={setUid}
                                intHotelRoute={false}
                                isHotelInternational={isHotelInternational}
                                type={hotelInformation.type}
                            />
                        </Container>
                    ) : (
                        <DetailsHeader type="hotel" data={hotelInformation} />
                    )}
                </>
            ) : (
                <BaseDialog title={t("edit")} open={openSearchForm} handleClose={handleClose} top="0" icon="close">
                    <DialogContent dividers={true}>
                        <SearchFormContent
                            openSearchForm={openSearchForm}
                            setRequestFlag={setRequestFlag}
                            setUid={setUid}
                            intHotelRoute={false}
                            isHotelInternational={isHotelInternational}
                            type={hotelInformation.type}
                        />
                    </DialogContent>
                </BaseDialog>
            )}
        </>
    );
}

export default connect()(HotelSearchForm);
